import React from "react";
import { Link } from "react-router-dom";
import PageShell from "../PageShell";
import { Reveal, TiltCard, WhatsAppDemo, PaymentDemo } from "../UIKit";

const pillars = [
  { tag: "SECURITY", title: "AI-based visitor & vehicle entry", body: "Number-plate and facial recognition move cabs and deliveries through the gate automatically — no manual plate entry, no one-by-one approvals." },
  { tag: "PRIVACY", title: "Data hosted on your society's own server", body: "Visitor logs and financial records stay with your society, not on a shared corporate cloud." },
  { tag: "ADMIN", title: "WhatsApp-based admin", body: "Residents and committee members handle bookings, complaints, and notices directly over WhatsApp, in text or voice." },
  { tag: "MAINTENANCE", title: "Predictive maintenance alerts", body: "IoT sensors on lifts and pumps flag developing faults before they turn into breakdowns and emergency repair bills." },
  { tag: "HARDWARE", title: "Hardware-as-a-Service", body: "Cameras and sensors are included with your subscription instead of a large upfront purchase." },
];

export default function ProductPage({ onAuthClick }) {
  return (
    <PageShell
      onAuthClick={onAuthClick}
      eyebrow="The product"
      title="Everything your society needs, in one app."
      lede="Visitor management, accounting, and helpdesk — plus the automation that saves your guards and committee real time."
      sceneMode="pillars"
      sceneData={pillars}
      seoTitle="Product — Bellboy Security & Society Management App"
      seoDescription="Bellboy's core features: AI-based visitor and vehicle entry, server-hosted privacy, WhatsApp admin, predictive maintenance, and Hardware-as-a-Service."
    >
      <section className="page-section">
        <div className="pillar-grid">
          {pillars.map((p, i) => (
            <Reveal key={p.title} delay={i * 80}>
              <TiltCard className="pillar-card">
                <span className="pillar-tag">{p.tag}</span>
                <h3>{p.title}</h3>
                <p>{p.body}</p>
              </TiltCard>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="page-section">
        <div className="demo-row" style={{ marginTop: 0 }}>
          <Reveal className="demo-copy" style={{ color: "var(--ink)" }}>
            <span className="pillar-tag">LIVE DEMO</span>
            <h3 style={{ color: "var(--indigo)", textShadow: "none" }}>Bookings and complaints, handled over WhatsApp.</h3>
            <p style={{ color: "rgba(20,23,51,0.8)" }}>
              A resident or committee member sends a message the way they already message anyone else — and it
              gets handled. No new habit to form.
            </p>
          </Reveal>
          <Reveal delay={100}>
            <WhatsAppDemo />
          </Reveal>
        </div>
        <div className="demo-row demo-row-reverse">
          <Reveal className="demo-copy" style={{ color: "var(--ink)" }}>
            <span className="pillar-tag">LIVE DEMO</span>
            <h3 style={{ color: "var(--indigo)", textShadow: "none" }}>Payments, tracked the moment they land.</h3>
            <p style={{ color: "rgba(20,23,51,0.8)" }}>
              The committee sees collections update in real time — who's paid, who hasn't — without chasing
              anyone for a screenshot.
            </p>
          </Reveal>
          <Reveal delay={100}>
            <PaymentDemo />
          </Reveal>
        </div>
        <Reveal delay={140}>
          <Link to="/market" className="section-btn">See the market opportunity →</Link>
        </Reveal>
      </section>
    </PageShell>
  );
}
